export const constants = {
  exclamationImagePath : 'assets/exclamationmark/exclamation-mark.svg'
};

export enum CARD_ACTIONS {
  EVENT_PANEL = 'open_event',
  SET_TOOLTIP = 'setToolTip'
}
